const state = {
  showOverlay: false,
  subjectId: null,
  subjectType: "",
};
const mutations = {
  showOverlay(state, payload) {
    state.showOverlay = payload;
  },
  setSubjectId(state, payload) {
    state.subjectId = payload;
  },
  setSubjectType(state, payload) {
    state.subjectType = payload;
  },
  reset(state) {
    state.showOverlay = false;
    state.subjectId = null;
    state.subjectType = "";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/apt-logs.js